import { render, staticRenderFns } from "./SyncTable.vue?vue&type=template&id=a205b674&scoped=true&lang=pug&"
import script from "./SyncTable.vue?vue&type=script&lang=js&"
export * from "./SyncTable.vue?vue&type=script&lang=js&"
import style0 from "./SyncTable.vue?vue&type=style&index=0&id=a205b674&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a205b674",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/zx/@sdc/toolkit/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VDataTable,VFlex,VIcon,VLayout})
